import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {BaseSkeletonsComponent} from "../../../core/components/base-skeletons/base-skeletons.component";
import {NgClass} from "@angular/common";
import {NgxSkeletonLoaderModule} from "ngx-skeleton-loader";

@Component({
  selector: "app-skeleton-works",
  templateUrl: "./skeleton-works.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, NgxSkeletonLoaderModule],
})
export class SkeletonWorksComponent extends BaseSkeletonsComponent {
  @Input() slideshow = false;
}
